module.exports = __webpack_public_path__ + "static/media/calpd.a0c78008.png";